module.exports = __webpack_public_path__ + "static/media/iCiel-Gotham.6e22e421.eot";